import { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX, ArrowRight } from 'lucide-react';
import { VIDEO_SHOWCASE } from '../constants/testIds';

export const VideoShowcase = () => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setMuted(videoRef.current.muted);
  };

  return (
    <section id="warehouse-video" data-testid={VIDEO_SHOWCASE.section} className="relative bg-brand-bg py-24 sm:py-32">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl lg:text-5xl">
          See Our Operation In Action
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-brand-muted text-base sm:text-lg">
          Our crew handles warehousing, inventory &amp; bulk tire orders every day! We are happy to assist you.
        </p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative mt-12 rounded-2xl border border-brand-border overflow-hidden bg-black"
        >
          <video
            ref={videoRef}
            data-testid={VIDEO_SHOWCASE.player}
            className="w-full h-auto block"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src="/videos/warehouse-showcase.webm" type="video/webm" />
            <source src="/videos/warehouse-showcase.mp4" type="video/mp4" />
          </video>
          <button
            type="button"
            onClick={toggleMute}
            data-testid={VIDEO_SHOWCASE.muteToggle}
            className="absolute bottom-4 right-4 inline-flex items-center justify-center w-10 h-10 rounded-full bg-brand-bg/80 border border-brand-border text-brand-text hover:border-brand-amber transition-colors"
            aria-label={muted ? 'Unmute video' : 'Mute video'}
          >
            {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
          </button>
        </motion.div>

        <div className="mt-8">
          <a
            href="#order-form"
            data-testid={VIDEO_SHOWCASE.cta}
            className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3.5 transition-colors"
          >
            Request a Quote
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
